module.exports = __webpack_public_path__ + "static/readMore-de9ba9a51f875824f127c2f0037e83c3.mp3";